import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { GlobalMenuGroupsRouteNames, GlobalMenuGroupsRoutePathNames } from '../../../../enums';

const Component = () => import('./BrandActivityLog.vue');

export default {
  path: buildChildURL(GlobalMenuGroupsRoutePathNames.ACTIVITY_LOG),
  name: GlobalMenuGroupsRouteNames.BRAND_ACTIVITY_LOG,
  component: Component,
} as RouteRecordRaw;
